import styled from "styled-components";
import { FancyTitle } from "./components/fancyTitle";
import { useNuovoRistoranteQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import React from "react";
import { FancyButton } from "./components/button";
const BlockContainer = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  img {
    height: 80px;
  }
  h3 {
    font-family: "Caviar Dreams";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    letter-spacing: 0.26em;
    color: #a2a087;
  }
  p {
    max-width: 300px;
    height: 100px;
    text-align: center;
  }
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  padding: 50px;

  @media (min-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
function Offer(props: {
  title: string;
  img: string;
  text?: React.ReactNode;
  menuLink?: string;
}) {
  return (
    <>
      <BlockContainer>
        <img src={props.img}></img>
        <h3>{props.title}</h3>

        <p>{props.text}</p>
        {props.menuLink && (
          <a href={props.menuLink}>
            <FancyButton>Menù</FancyButton>
          </a>
        )}
      </BlockContainer>
    </>
  );
}
export function Offerta() {
  const { data } = useNuovoRistoranteQuery();

  return (
    <>
      <FancyTitle text='Offerta' double />
      <Container>
        <Offer
          title='BUSINESS LUNCH'
          img='/kum/tie.webp'
          text={documentToReactComponents(
            data?.nuovoRistorante?.loungeBar?.json
          )}
          menuLink={data?.nuovoRistorante?.menuLunch?.url as string}
        />
        <Offer
          title='ALL DAY DINING'
          img='/kum/fork.webp'
          text={documentToReactComponents(
            data?.nuovoRistorante?.allDayDining?.json
          )}
          menuLink={data?.nuovoRistorante?.menuAllDay?.url as string}
        />
        <Offer
          title='DINNER'
          img='/kum/bell.webp'
          text={documentToReactComponents(data?.nuovoRistorante?.dinner?.json)}
          menuLink={data?.nuovoRistorante?.menuDinner?.url as string}
        />
        <Offer
          title='BREAKFAST'
          img='/kum/breakfast.webp'
          text={documentToReactComponents(
            data?.nuovoRistorante?.breakfast?.json
          )}
          menuLink={data?.nuovoRistorante?.menu?.url as string}
        />
        <Offer
          title='BRUNCH'
          img='/kum/brunch.webp'
          text={documentToReactComponents(data?.nuovoRistorante?.brunch?.json)}
          menuLink={data?.nuovoRistorante?.menuBrunch?.url as string}
        />
        <Offer
          title='DRINK LIST'
          img='/kum/drink.webp'
          text={documentToReactComponents(
            data?.nuovoRistorante?.drinklist?.json
          )}
          menuLink={data?.nuovoRistorante?.drinklistMenu?.url as string}
        />
      </Container>
    </>
  );
}
